import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const CompanySettingsPage = lazyWithRetry(() => import('./pages/CompanySettingsPage'))

const routes: AppRoute[] = [
  {
    path: 'company-settings',
    children: [
      {
        index: true,
        element: CompanySettingsPage,
        meta: {
          title: 'companySettings.title',
          require: { minRole: ROLE.MEMBER }, // All members can view company settings
        },
      },
    ],
  },
]

export default routes
